import dayjs from 'dayjs';

export const formatDateOnRequest = (date: string | undefined | null): string | undefined => {
  if (!date) return undefined; // 이 줄 추가!

  const dateObj = dayjs(date);
  if (dateObj.isValid()) {
    return dateObj.format('YYYY-MM-DD');
  } else {
    return undefined;
  }
};

export const formatRequestToDate = (date: string | undefined | null, replace?: string): string => {
  const dateObj = dayjs(date);
  if (dateObj.isValid()) {
    return dateObj.format('MMM DD YYYY').toUpperCase();
  } else {
    return replace ?? 'Add dates';
  }
};

export const formatRequestToDateTime = (date: string | undefined | null, replace?: string): string => {
  const dateObj = dayjs(date);
  if (dateObj.isValid()) {
    return dateObj.format('MMM DD YYYY HH:mm').toUpperCase();
  } else {
    return replace ?? 'Add dates';
  }
};

export const formatStringToDate = (date: string | undefined | null): Date | null => {
  if (date && dayjs(date).isValid()) {
    return dayjs(date).toDate();
  } else {
    return null;
  }
};

export const formatDateToString = (date: Date | null): string => {
  if (date) {
    return dayjs(date).format('MMM DD YYYY').toUpperCase();
  } else {
    return '';
  }
};

export const formatPrice = (price: number | null): string => {
  // M, K 단위로 변환
  // 10000000 => 10M
  // 500000 => 500K

  if (!price) {
    return '-';
  }

  if (price >= 1000000) {
    return `${price / 1000000}M`;
  } else if (price >= 1000) {
    return `${price / 1000}K`;
  } else {
    return `${price}`;
  }
};

export const formatPriceOnlyM = (price: number | null): string => {
  if (!price) {
    return '-';
  }

  return `${price / 1000000}M`;
};

export const formatPriceOnlyK = (price: number | null): string => {
  if (!price) {
    return '-';
  }

  return `${price / 1000}K`;
};
